import Icon from '../components/Icon.vue'

Icon.register({
  toilet: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M368 48h-16v156.7c20.2 10.1 32 22.2 32 35.3 0 67.2-34.6 126.2-86.8 160.5l21.4 70.2c6.3 20.5-9.1 41.3-30.6 41.3h-192c-21.5 0-36.9-20.8-30.6-41.3l21.4-70.2c-52.2-34.3-86.8-93.3-86.8-160.5 0-13.1 11.8-25.2 32-35.3v-156.7h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zM80 72v16c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zM192 272c77.1 0 139.6-14.3 139.6-32s-62.5-32-139.6-32-139.6 14.3-139.6 32 62.5 32 139.6 32z'
      }
    ]
  }
})
